export function formatPercentOff(percentOff: number): string;
export function formatPercentOff(
  percentOff: number | null | undefined,
): string | null;
export function formatPercentOff(
  percentOff: number | null | undefined,
): string | null {
  if (percentOff == null) return null;
  return `${percentOff}% Off`;
}
